import { FC } from 'react';

export const Debt: FC = () => (
  <svg fill="currentColor" viewBox="0 0 297.21 297.21" strokeWidth="2">
    <g>
      <g>
        <g>
          <path
            d="M277.177,276.19L277.177,276.19c-0.001,5.252-4.272,9.524-9.525,9.524s-9.524-4.271-9.524-9.524
				c0-10.505-8.543-19.048-19.048-19.048s-19.048,8.543-19.048,19.048c0,5.252-4.271,9.524-9.524,9.524h-8.371
				c-2.505,0-4.962-1.019-6.733-2.79l-6.733-6.733l14.286-14.286l-9.605-9.605c5.005-10.31,7.633-21.733,7.633-33.252
				c0-8.319-1.386-16.31-3.862-23.81h41.957V19.048h-66.667V0H67.652v19.048H0.986v176.19h51.481
				c-2.476,7.5-3.862,15.49-3.862,23.81c0,42.01,34.181,76.19,76.19,76.19c11.519,0,22.943-2.629,33.252-7.633l9.605,9.605
				l14.286-14.286l6.733,6.733c3.543,3.548,8.452,5.581,13.467,5.581h8.371c10.505,0,19.048-8.543,19.048-19.048
				c0-5.252,4.271-9.524,9.524-9.524c5.252,0,9.524,4.271,9.524,9.524c0,10.505,8.543,19.048,19.048,19.048
				s19.048-8.543,19.048-19.048v-28.571h-9.524V276.19z M77.176,9.524h85.714v9.524H77.176V9.524z M10.51,28.571h57.142h104.762
				h57.143v67.167l-33.333,3.705V85.714H162.89V100H77.176V85.714H43.843v13.729L10.51,95.738V28.571z M186.7,95.238v28.571h-14.286
				V95.238H186.7z M67.652,95.238v28.571H53.367V95.238H67.652z M10.51,185.714v-80.395l33.333,3.705v24.31h33.333v-23.81h85.714
				v23.81h33.333v-24.31l33.333-3.705v80.395H193.2c-12.395-25.329-38.357-42.857-68.405-42.857
				c-30.048,0-56.01,17.529-68.405,42.857H10.51z M167.653,283.743l-7.843-7.848l-3.124,1.705c-9.733,5.31-20.757,8.114-31.89,8.114
				c-36.762,0-66.667-29.905-66.667-66.667c0-36.762,29.905-66.667,66.667-66.667s66.667,29.905,66.667,66.667
				c0,11.133-2.805,22.157-8.11,31.886l-1.705,3.124l7.843,7.848L167.653,283.743z"
          />
          <polygon
            points="286.7,228.571 286.7,219.048 277.176,219.048 277.176,228.571 267.652,228.571 267.652,238.095 277.176,238.095
				277.176,228.572 286.7,228.572 286.7,238.095 296.224,238.095 296.224,228.571 			"
          />
          <path
            d="M120.033,200h9.524c2.629,0,4.762,2.133,4.762,4.762h9.524c0-7.876-6.41-14.286-14.286-14.286v-9.524h-9.524v9.524
				c-7.876,0-14.286,6.41-14.286,14.286v4.762c0,7.876,6.41,14.286,14.286,14.286h9.524c2.629,0,4.762,2.133,4.762,4.762v4.762
				c0,2.629-2.133,4.762-4.762,4.762h-9.524c-2.629,0-4.762-2.133-4.762-4.762h-9.524c0,7.876,6.41,14.286,14.286,14.286v9.524
				h9.524v-9.524c7.876,0,14.286-6.41,14.286-14.286v-4.762c0-7.876-6.41-14.286-14.286-14.286h-9.524
				c-2.629,0-4.762-2.133-4.762-4.762v-4.762C115.271,202.133,117.405,200,120.033,200z"
          />
          <rect x="115.271" y="80.952" width="9.524" height="9.524" />
          <rect x="134.319" y="80.952" width="9.524" height="9.524" />
          <rect x="96.224" y="80.952" width="9.524" height="9.524" />
        </g>
      </g>
    </g>
  </svg>
);

export default Debt;
